export const locale = {
    lang: 'en',
    data: {
        'TOOTIPORTITLE':{
            'AddChangeProfilePicture':'Add/Change Picture',
            'RemoveProfilePicture':'Remove Picture',
        }
    }
};
